<div class="netop-toggle-container" [ngStyle]="{'color': color}">
  <div class="netop-toggle-option" *ngFor="let option of toggleOptions"
       [ngClass]="optionClass"
       [ngStyle]="option.isSelected ? {background: color, color: '#ffffff'}: {background: '#ffffff', color: color}"
       (click)="onOptionSelected(option)">{{option.value}}</div>
</div>
